// checkAuth
const REQUEST = 'REQUEST'
const SUCCESS = 'SUCCESS'
const ERROR = 'ERROR'

// userProfile
const CLEAR = 'CLEAR'
const CHANGE = 'CHANGE'
const EXTEND = 'EXTEND'
const LOGOUT = 'LOGOUT'

// handleError
const CATCH = 'CATCH'

function createRequestTypes (base) {
  const res = {};
  [REQUEST, SUCCESS, ERROR, CATCH,
    CLEAR, CHANGE, EXTEND, LOGOUT].forEach(type => {
    res[type] = `${base}_${type}`
  })
  return res
}

export const CHECKAUTH = createRequestTypes('CHECKAUTH')
export const USERPROFILE = createRequestTypes('USERPROFILE')
export const HANDLEERROR = createRequestTypes('HANDLEERROR')
